require('@fancyapps/fancybox')

$(function () {
	/*/
	 *  Fancybox
	/*/
		$().fancybox({
			selector : '[ps-fancybox]',
			loop: true,
			infobar: false,
			buttons: [
				"zoom",
				"fullScreen",
				"close"
			],
			protect: true,
			lang: 'pt',
			i18n: {
				pt: {
					CLOSE: 'Fechar',
					NEXT: 'Próximo',
					PREV: 'Anterior',
					ERROR: "Erro ao tentar carregar imagem.",
					PLAY_START: 'Iniciar slides',
					PLAY_STOP: "Pausar slides",
					FULL_SCREEN: "Tela cheia",
					THUMBS: 'Miniaturas',
					DOWNLOAD: 'Download',
					SHARE: 'Compartilhar',
					ZOOM: 'Ampliar'
				}
			}
        })
})